<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <div>
          <CaptionWhite label="진행 중인 프로젝트"></CaptionWhite>
        </div>
        <div class="text mobile">
          <br />
          먼데이리스는 <br />
          프로토타입을 5일 안에 <br />드릴수 있습니다
          <p style="font-weight: 300; font-size: 17px; color:#ffffff">
            개발사를 잘못 선택하시면 소중한 예산을 낭비하실 수 있습니다
          </p>
        </div>
        <div class="text pc">
          <br />
          먼데이리스는 프로토타입을 5일 안에 드릴수 있습니다
          <p style="font-weight: 300; font-size: 17px; color:#ffffff">
            개발사를 잘못 선택하시면 소중한 예산을 낭비하실 수 있습니다
          </p>
        </div>

        <div style="text-align: center; display: flex; justify-content: center; padding-bottom: 30px;">
          <ul>
            <li v-for="m of project_list" class="card_bg">
              <div style="font-weight: 700; display: block; font-size: 18px">
                {{ m.name }}
              </div>
              <p style="font-weight: 300; display: block; font-size: 15px">
                {{ m.sub_title }}
              </p>
              <p
                style="
                  font-weight: 300;
                  font-size: 15px;
                  width: 100%;
                  height: 50%;
                  white-space: normal;
                "
              >
                {{ m.desc }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
  
<script>
import Caption from "../components/Caption.vue";
import CaptionWhite from "../components/CaptionWhite.vue";
import client from "../client/client";

export default {
  components: {
    Caption,
    CaptionWhite,
  },
  data() {
    return {
      project_list: [{}, {}, {}],
    };
  },

  mounted() {
    client
      .get("/api/project/list")
      .then((res) => {
        this.project_list = res.list;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 450px;
  position: relative;
  overflow: hidden;
  background-color: #215fe6;
  padding-bottom: 50px;
}

.content {
  width: 1140px;
  max-width: 1140px;
  text-align: center;
}

ul {
  margin-top: 40px;
  width: 100%;
  height: 180px;
  list-style-type: none;
  white-space: nowrap;
  overflow-x: scroll;
  padding-inline-start: 0px;
}
li.card_bg:not(:last-child) {
  margin-right: 15px;
  margin-bottom: 0px;
}

ul li {
  display: inline-block;
}

.text {
  color: #ffffff;
  font-size: 32px;
  font-weight: 500;
  margin-top: 35px;
}

.card_bg {
  padding: 20px;
  text-align: left;
  width: 352px;
  height: 162px;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    justify-content: center;
    width: 100vw;
    height: fit-content;
    position: relative;
    overflow: hidden;
    background-color: #215fe6;
  }

  .content {
    width: 100%;
    text-align: center;
  }

  ul {
    width: fit-content;
    height: fit-content;
    list-style-type: none;
    overflow: hidden;
    overflow-y: scroll;
    padding-inline-start: 0px;
  }

  li.card_bg:not(:last-child) {
    margin-right: 0px;
    margin-bottom: 15px;
  }

  ul li {
    display: block;
  }

  .text {
    color: #ffffff;
    font-size: 28px;
    font-weight: 500;
    margin-top: 15px;
  }

  .card_bg {
    padding: 20px;

    text-align: left;
    width: 80vw;
    height: 162px;
    background: #ffffff;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
    border-radius: 16px;
  }
}

</style>
  